module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Wolves.388adcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Wolves.jpg
// module id = lTEq
// module chunks = 0